import React, {Component} from 'react';
import {Platform, StyleSheet, View, Text, Dimensions,ScrollView} from 'react-native'
import { JDText, JDDevice,JDVideoPlayer } from '@jdreact/jdreact-core-lib'
export default class VideoPlayer extends Component{
    constructor(props) {
        super(props);
        this.state = {

        }
    }
    // 外部控制是否播放
    outControlPlay = () => {
        this.videoRef && this.videoRef.play && this.videoRef.play(); 
    }
    outControlPause = () => {
        this.videoRef && this.videoRef.pause && this.videoRef.pause();
    }
    render(){
        const {surfacePlot,playUrl} = this.props;
        return (
                <ScrollView>
                    <JDVideoPlayer
                        // style={{height: '100%', width: '100%'}}
                        style={{height: JDDevice.getRpx(560), width: JDDevice.width}}
                        ref={(video) => {this.videoRef = video}}
                        audioOut={true}
                        source={{
                            url: playUrl,
                            imgUrl: surfacePlot,
                            headers: {
                                'refer': 'myRefer'
                            },
                            pageId:'video_swiper',
                            referPageId:'video_swiper_refer',
                            projectId:'video_swiper_project_id',
                            // mute:true,
                            articleId:'video_article_id',
                            audioOut:true,       // 设置外放（喇叭）。默认是内放（听筒）
                        }}
                    />
            </ScrollView>
        )
    }
}